import { Skeleton } from "@ds/react";
import * as S from "./SkeletonCard.style";

const SkeletonCard = ({ rows = 1, lines = 4 }) => {
  const rowsArr = Array.from({ length: rows });

  return (
    <S.Container>
      {rowsArr.fill(null).map((_, index) => (
        <S.Card key={index}>
          <Skeleton lines={lines} />
        </S.Card>
      ))}
    </S.Container>
  );
};

export default SkeletonCard;
